import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@devhop/ui";
import { Link } from "@tanstack/react-router";
import { useFormCategoriesLookupQuery } from "@/modules/forms/presentation/api/queries";

const NONE = "__none__";

type FormCategorySelectProps = {
  id?: string;
  value: string | null;
  disabled?: boolean;
  onChange: (categoryId: string | null) => void;
  showManageLink?: boolean;
};

export function FormCategorySelect({
  id = "form-category",
  value,
  disabled,
  onChange,
  showManageLink = true,
}: FormCategorySelectProps) {
  const lookup = useFormCategoriesLookupQuery();
  const items = lookup.data ?? [];

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>ຫມວດຫມູ່</Label>
      <Select
        value={value ?? NONE}
        disabled={disabled || lookup.isLoading}
        onValueChange={(v) => onChange(v === NONE ? null : v)}
      >
        <SelectTrigger id={id}>
          <SelectValue placeholder="— ບໍ່ມີຫມວດ —" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>— ບໍ່ມີຫມວດ —</SelectItem>
          {items.map((c) => (
            <SelectItem key={c.id} value={c.id}>
              {c.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {showManageLink ? (
        <Link
          to="/app/forms/categories"
          className="text-muted-foreground text-xs hover:text-foreground hover:underline"
        >
          ຈັດການຫມວດຫມູ່
        </Link>
      ) : null}
    </div>
  );
}
